export default {
  init() {
    // JavaScript to be fired on the testimonials page

    $('.testimonials').accordion({
      autoHeight: false,
      heightStyle: 'content',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/clientTestimonials.js